<script>
import {Modal} from 'bootstrap';
import * as Ladda from 'ladda';
import convert from 'client-side-image-resize';
import _ from 'lodash';

export default {
    props: {
        url: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            modal: null,
            form: {
                name: null,
                content: null,
                photo: null,
            },
            photo: null,
            saving: false,
            submitButton: null,
        }
    },
    mounted() {
        this.modal = new Modal(this.$el);

        this.modal.show();

        this.$el.addEventListener('hidden.bs.modal', () => {
            this.$emit('closed');
        });

        this.$captchaInit();

        this.submitButton = Ladda.create(this.$el.querySelector('button[type="submit"]'))
    },
    methods: {

        setPhoto(event) {
            this.photo = event.target.files[0] ?? null;
        },

        resizeImage() {
            const fr = new FileReader();
            const img = new Image();

            return new Promise((resolve) => {
                fr.onload = () => {
                    img.onload = () => {
                        const targetMaxSize = 1024;

                        let originalWidth = img.width;
                        let originalHeight = img.height;

                        let resizedWidth;
                        let resizedHeight;

                        if (originalWidth > originalHeight) {
                            resizedWidth = targetMaxSize;
                            resizedHeight = Math.round(originalHeight * (targetMaxSize / originalWidth));
                        } else {
                            resizedHeight = targetMaxSize;
                            resizedWidth = Math.round(originalWidth * (targetMaxSize / originalHeight));
                        }

                        convert({
                            file: this.photo,
                            width: resizedWidth,
                            height: resizedHeight,
                            type: 'jpeg'
                        }).then(resp => {
                            this.form.photo = resp;
                            resolve();
                        }).catch(error => {
                            this.$noty.success(error);
                            this.saving = false;
                        });
                    }

                    img.src = fr.result;
                };

                fr.readAsDataURL(this.photo);
            });
        },

        async submit() {
            this.saving = true;

            this.resizeImage()
                .then(() => {
                    this.storeTestimonial()
                });

        },

        async storeTestimonial() {
            let formData = new FormData();

            formData.append('g-recaptcha-response', await this.$captcha('testimonial_create'));

            _.forEach(this.form, (value, key) => {
                formData.append(key, value);
            });

            axios.post(this.url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                onUploadProgress: (progressEvent) => {
                    this.submitButton.setProgress(
                        parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                    );

                }
            }).then(({data}) => {
                this.$noty.success(data);
                this.modal.hide();
            }).catch(errors => {
                this.saving = false;
                this.$noty.ajaxError(errors);
            })
        },

    },
    watch: {

        saving(value) {
            if (value) {
                this.submitButton.start();
            } else {
                this.submitButton.stop();
            }
        },

    },
}
</script>

<template>
    <div class="modal fade" id="testimonialCreateModal"
         data-bs-backdrop="static"
         data-bs-keyboard="false"
         tabindex="-1"
         aria-labelledby="testimonialCreateModalLabel"
         aria-hidden="true"
    >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="testimonialCreateModalLabel">
                        Utaztál már velünk? Írd meg a véleményed te is
                    </h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="saving"></button>
                </div>
                <div class="modal-body text-start">
                    <form :action="url" method="POST" id="testimonialCreateModalForm" v-on:submit.prevent="submit">

                        <div class="mb-3">
                            <label for="testimonialCreateModalFormName" class="form-label">
                                Név
                            </label>

                            <input type="text" class="form-control"
                                   name="name"
                                   id="testimonialCreateModalFormName"
                                   v-model="form.name"
                                   maxlength="255"
                                   required
                                   :disabled="saving"
                            >
                        </div>

                        <div class="mb-3">
                            <label for="testimonialCreateModalContent" class="form-label">
                                Véleményem, tapasztalatom
                            </label>

                            <textarea class="form-control"
                                      name="content"
                                      id="testimonialCreateModalContent"
                                      v-model="form.content"
                                      maxlength="2000"
                                      required
                                      :disabled="saving"
                            ></textarea>
                        </div>

                        <div class="mb-3">
                            <label for="testimonialCreateModalFormPhoto" class="form-label">
                                Feltöltök egy fotót magamról
                            </label>

                            <input type="file" class="form-control"
                                   name="name"
                                   id="testimonialCreateModalFormPhoto"
                                   accept="image/bmp,image/gif,image/jpeg,image/png"
                                   v-on:change="setPhoto"
                                   required
                                   :disabled="saving"
                            >
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="saving">
                        Mégse
                    </button>

                    <button type="submit" class="btn btn-primary" form="testimonialCreateModalForm">
                        Elküld
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
